const music = [
  {
    title: 'Ballade Fantastique by Henriette Renié',
    subtitle: 'Performed in 2022',
    url: '6UmSYtq1i4Q'
  },
  {
    title: 'Rhapsodie by Marcel Grandjany',
    subtitle: 'Performed in 2022',
    url: 'wDLrlpiEsC4'
  },
  {
    title: 'Spanish Dance No. 1 by Manuel de Falla',
    subtitle: 'Performed in 2017',
    url: 'JljbdNCfgLc'
  },
  {
    title: 'Contemplation by Henriette Renié',
    subtitle: 'Performed in 2014',
    url: 'IlhuLDxSADg'
  }
]

export default music



// WEBPACK FOOTER //
// ./src/containers/Music/components/MusicCarousel/music.js